import { Controller } from "stimulus"
import * as bootstrap from "bootstrap"

// Connects to data-controller="tooltip"
export default class extends Controller {
  connect() {
    console.log('Tooltip controller connected')
    console.log('Bootstrap available:', typeof bootstrap !== 'undefined')
    this.initializeTooltips()
    this.initializePopovers()
  }

  disconnect() {
    console.log('Tooltip controller disconnected')
    this.destroyTooltips()
    this.destroyPopovers()
  }

  initializeTooltips() {
    // Find all tooltip elements within this controller's scope
    const tooltipTriggerList = Array.from(
      this.element.querySelectorAll('[data-bs-toggle="tooltip"]')
    )
    
    console.log('Initializing', tooltipTriggerList.length, 'tooltips')
    
    // Initialize Bootstrap tooltips
    this.tooltips = tooltipTriggerList.map(tooltipTriggerEl => {
      return new bootstrap.Tooltip(tooltipTriggerEl, {
        trigger: 'hover'
      })
    })
    
    console.log('Tooltips initialized:', this.tooltips.length)
  }

  initializePopovers() {
    // Find all popover elements within this controller's scope
    const popoverTriggerList = Array.from(
      this.element.querySelectorAll('[data-bs-toggle="popover"]')
    )
    
    console.log('Initializing', popoverTriggerList.length, 'popovers')
    
    // Initialize Bootstrap popovers with HTML enabled
    this.popovers = popoverTriggerList.map(popoverTriggerEl => {
      return new bootstrap.Popover(popoverTriggerEl, {
        html: true,
        trigger: 'focus', // Dismiss when clicking outside
        sanitize: false // Allow HTML links
      })
    })
    
    console.log('Popovers initialized:', this.popovers.length)
  }

  destroyTooltips() {
    // Clean up tooltips when controller is disconnected
    if (this.tooltips) {
      this.tooltips.forEach(tooltip => tooltip.dispose())
    }
  }

  destroyPopovers() {
    // Clean up popovers when controller is disconnected
    if (this.popovers) {
      this.popovers.forEach(popover => popover.dispose())
    }
  }
}
